// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2YJCx","requiredAsterisk":"Info_requiredAsterisk__3M-Au"};